import { createStructuredSelector } from 'reselect';
import * as selectors from '../App/selector';

export const mapStateToProps = createStructuredSelector({
    router: selectors.selectRouter,
    isLoggedIn: selectors.selectIsLoggedIn,
    customer: selectors.selectCustomer,
    isContentEnabled: selectors.selectIsContentEnabled,
});

export type State = ReturnType<typeof mapStateToProps>;
